import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;


export const requestConfigList = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configlist`, params: params });
    return res.data;
};
export const requestEditConfig = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/addconfig`, params: params });
    return res.data;
};
export const requestDelConfig = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configdel`, params: params });
    return res.data;
};
export const requestGetConfig = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/getconfigbyid`, params: params });
    return res.data;
};
export const requestGetAllConfig = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/getconfig`, params: params });
    return res.data;
};
// 全部父节点
export const requestGetAllConfigPid0 = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/getconfigpid0`, params: params });
    return res.data;
};
// 编辑左边节点
export const requestEditValue = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/editvaluebyid`, params: params });
    return res.data;
};

// 删除左边节点
export const requestConfigDel = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configdel`, params: params });
    return res.data;
};

// 设备右侧列表
export const requestConfigList2 = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configlist2`, params: params });
    return res.data;
};

// 删除通用config
export const requestConfigDel1 = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configdel1`, params: params });
    return res.data;
};

//根据节点品牌获取节点型号
export const requestConfigXh = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/configxh`, params: params });
    return res.data;
};

export const requestConfigList3= async params => {
    const res = await axios({ method: 'post', url: `${base}/config/configlist`, params: params });
    return res.data;
};

export const requestEditConfig3= async params => {
    const res = await axios({ method: 'post', url: `${base}/config/editconfig`, params: params });
    return res.data;
};
export const requestDeleteConfig3= async params => {
    const res = await axios({ method: 'post', url: `${base}/config/deleteconfig`, params: params });
    return res.data;
};
export const requestConfigInfo3= async params => {
    const res = await axios({ method: 'post', url: `${base}/config/configinfo`, params: params });
    return res.data;
};

export const requestConfigalllisttype3= async params => {
    const res = await axios({ method: 'post', url: `${base}/config/configalllisttype`, params: params });
    return res.data;
};

// 事项类型配置列表
export const requestTaskTypeConfigList = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/tasktypeconfiglist`, params: params });
    return res.data;
};
// 事项类型配置保存
export const requestTaskTypeConfigSave = async params => {
    const formData = new URLSearchParams();
    for (const key in params) { formData.append(key, params[key]); }
    const res = await axios({ method: 'post', url: `${base}/config/tasktypeconfigsave`, data: formData });
    return res.data;
};
// 根据事项类型名称查询配置
export const requestTaskTypeConfigByType = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/tasktypeconfiginfo`, params: params });
    return res.data;
};

// 获取有"启动任务"权限的用户
export const requestGetStartUsers = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/getstartusers`, params: params });
    return res.data;
};
// 保存默认任务启动人配置
export const requestSaveDefaultStarter = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/savedefaultstarter`, params: params });
    return res.data;
};
// 获取默认任务启动人配置
export const requestGetDefaultStarter = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/getdefaultstarter`, params: params });
    return res.data;
};

// 知识库-更新记录列表（由近到远）
export const requestUpdateRecordList = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/updaterecordlist`, params: params });
    return res.data;
};
// 知识库-添加更新记录（文本 + 图片）
export const requestAddUpdateRecord = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/addupdaterecord`, params: params });
    return res.data;
};
// 知识库-流程表单对照表列表（全部，不分页）
export const requestProcessFormList = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/processformlist`, params: params });
    return res.data;
};
// 知识库-新增流程表单对照表
export const requestAddProcessForm = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/addprocessform`, params: params });
    return res.data;
};
// 知识库-编辑流程表单对照表
export const requestEditProcessForm = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/editprocessform`, params: params });
    return res.data;
};
// 知识库-删除流程表单对照表
export const requestDelProcessForm = async params => {
    const res = await axios({ method: 'post', url: `${base}/config/delprocessform`, params: params });
    return res.data;
};

